import { ITranslation } from '../LoginModal/types'

const translations: ITranslation = {
    'Job alert created successfully': 'Tạo thông báo việc làm thành công',
    'Job alert "{0}" created': 'Thông báo việc làm "{0}" đã được tạo',
    'Job alert updated successfully': 'Đã cập nhật thông báo việc làm',
    'Job alert "{0}" updated': 'Thông báo việc làm "{0}" đã được cập nhật',
    'Job alert deleted successfully': 'Đã xóa thông báo việc làm',
    'Job alert "{0}" deleted': 'Thông báo việc làm "{0}" đã được xóa',
    'You already created 10 job alerts!': 'Bạn đã tạo tối đa 10 Thông Báo Việc Làm!',
    'Job alert error': 'Lỗi',
    'You already created this job alert': 'Bạn đã tạo thông báo việc làm này trước đó!',
    'Receive Job Alerts': 'Nhận thông báo',
    'Job title': 'Chức danh việc làm',
    'This field is required': 'Thông tin bắt buộc',
    Required: 'Bắt buộc',
    Save: 'Lưu',
    Delete: 'Xoá',
    Cancel: 'Huỷ',
    Email: 'Email',
    App: 'Ứng dụng',
    Both: 'Cả hai',
    Remove: 'Xoá',
    'I want alerts': 'Nhận thông báo',
    Weekly: 'Hàng tuần',
    Daily: 'Hàng ngày',
    'Delete this Job Alert?': 'Xoá thông báo?',
    'You will not be able to receive email for job alert': 'Bạn sẽ ngừng nhận email thông báo việc làm này.',
    'Salary from': 'Mức lương tối thiểu',
    'Job level': 'Cấp bậc',
    Category: 'Ngành nghề',
    Location: 'Địa điểm',
    'No result': 'Không có kết quả',
    'Notification Settings': 'Thiết lập thông báo',
    'You can only choose maximum 3 locations': 'Bạn chỉ có thể chọn tối đa 3 địa điểm',
    'Notify via': 'Thông báo qua',
    Frequency: 'Tần suất',
    'Please select ...': 'Vui lòng chọn ...',
    'Discard this job alert?': 'Hủy thông báo việc làm?',
    'This job alert will not be saved': 'Thông báo việc làm sẽ không được lưu',
    Yes: 'Có',
    No: 'Không',
    'Enter email': 'Nhập email',
    'Enter job title': 'Nhập chức danh',
    "Can't delete this job alert": 'Không thể xóa thông báo việc làm này',
    "Can't update this job alert": 'Không thể cập nhật thông báo việc làm này',
    'Create Job Alert': 'Thông báo việc làm',
    'Update Your Profile': 'Cập nhật hồ sơ của bạn',
    'Attached CV': 'Hồ sơ đính kèm',
    Allow: 'Cho phép',
    'Select location': 'Chọn địa điểm',
    'Select job category': 'Chọn ngành nghề',
    Successful: 'Thành công',
    'It may take a few minutes to import the data...': 'Có thể mất vài phút để nhập dữ liệu ...',
    'Please fill in your correct Linkedln link. Example: https://www.linkedin.com/in/ryanroslansky/':
        'Vui lòng điền đúng liên kết Linkedln của bạn. Ví dụ: https://www.linkedin.com/in/ryanroslansky/',
    'Something went wrong. Can not import data, please try again.':
        'Có lỗi xảy ra không thể tự động điền dữ liệu. Vui lòng thử lại.',
    'Save time by importing your existing LinkedIn profile!':
        'Tiết kiệm thời gian bằng cách nhập hồ sơ LinkedIn hiện có của bạn!',
    'By clicking the “Import Profile” button, we will replace the information on VietnamWorks’ profile with the one from your LinkedIn account, such as Skills, Education, Experiences,… and you can not undo it.':
        'Bằng cách nhấp vào nút “Nhập hồ sơ”, chúng tôi sẽ thay thế thông tin trên hồ sơ của VietnamWorks bằng thông tin từ tài khoản LinkedIn của bạn, chẳng hạn như Kỹ năng, Học vấn, Kinh nghiệm,… và bạn không thể hoàn tác.',
    Processing: 'Đang xử lý',
    'Your LinkedIn profile has been updated to VietnamWorks’s profile successfully. Go to My Profile to review your updated profile.':
        'Hồ sơ trên Linkedln của bạn đã được cập nhật thành công lên hồ sơ của VietnamWorks. Đi tới "Hồ sơ của tôi" để xem lại hồ sơ cập nhật của bạn.',
    'Click “Import Again” to update new information from Linkedln.':
        'Nhấp vào “Nhập lại” để cập nhật thông tin mới từ Linkedln.',
    'Import again': 'Nhập lại',
    'Import Profile From LinkedIn': 'Nhập hồ sơ từ LinkedIn',
    'Import Profile': 'Nhập hồ sơ',
    'Enter your LinkedIn profile link': 'Nhập đường dẫn hồ sơ LinkedIn của bạn',
    'The LinkedIn URL you provided us is wrong or unavailable. Please check and Import Profile again.':
        'Đường dẫn hồ sơ LinkedIn mà bạn cung cấp không hợp lệ. Vui lòng thử lại.',
    'Importing...': 'Đang cập nhật...',
    'Your Linked profile has been updated to VietnamWorks’s profile successfully.':
        'Hồ sơ LinkedIn của bạn đã được cập nhật lên hồ sơ Vietnamworks thành công.',
    'Reload Profile': 'Tải lại trang',
    'to view the updated data.': 'để xem những thông tin đã được cập nhật.',
    Back: 'Trở về',
    'Go to': 'Đi tới',
    'My Profile': 'Hồ sơ của tôi',
    'to review your updated profile.': 'để xem lại hồ sơ cập nhật của bạn.',
    'my-profile': 'ho-so',
    'Email me similar jobs': 'Gửi tôi việc tương tự',
    'Receive job alerts for jobs like this search!': 'Gửi tôi việc tương tự',
    'Pay period': 'Thời gian trả lương',
    'Send me jobs': 'Nhận thông báo',
    'This is not a valid email address': 'Địa chỉ email không hợp lệ ',
    'Your email': 'Email của bạn',
    'Email to receive jobs': 'Email nhận thông báo',
    Close: 'Đóng',
    'Your comments make an important contribution to protecting the Job Seeker Community.':
        'Ý kiến đóng góp của bạn sẽ góp phần quan trọng để bảo vệ cộng đồng người tìm việc',
    'Report a job successfully': 'Báo cáo việc làm thành công',
    Submit: 'Gửi',
    Other: 'Khác',
    Report: 'Báo cáo',
    'characters remaining': 'ký tự còn lại',
    'Report this job': 'Báo cáo việc làm này',
    'Please input detail description for Other reason': 'Bạn cần nhập mô tả chi tiết cho Lý do khác',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'The Email must be a valid Email address.': 'Email không hợp lệ.',
    'Accept {0} digits.': 'Chấp nhận {0} chữ số.',
    'Accept {0} characters.': 'Chấp nhận {0} ký tự.',
    '{0} characters limit.': 'Tối đa {0} ký tự.',
    '{0} digits limit.': 'Tối đa {0} chữ số.',
    'Exceeded maximum character length of': 'Đã vượt quá độ dài ký tự tối đa là',
    Play: 'Phát',
    Pause: 'Tạm dừng',
    Month: 'Tháng',
    'Select job function': 'Chọn ngành nghề',
    'Add more criteria': 'Thêm điều kiện khác',
    "Create a job alert to seize a new opportunity. Don't miss the opportunity to find your dream job": 'Tạo thông báo việc làm để có cơ hội mới. Đừng bỏ lỡ cơ hội công việc mơ ước của bạn',
    "Expected working location": "Nơi làm việc mong muốn",
    "Create alert": "Tạo thông báo",
    "Job alert": "Thông báo việc làm",
    "Save alert": "Lưu",
}

export default translations
